// extracted by mini-css-extract-plugin
var _1 = "SummaryStyle-module__decoration___yuJzc";
var _2 = "SummaryStyle-module__summary___h5KsU";
var _3 = "SummaryStyle-module__tooltip-icon___CI1pz";
var _4 = "SummaryStyle-module__tooltip-icon___CI1pz";
export { _1 as "decoration", _2 as "summary", _3 as "tooltip-icon", _4 as "tooltipIcon" }
